import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import values from 'lodash/values';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import Button from '@Components/Button';
import { Checkbox } from '@els/els-react--checkbox';
import PreferredSuppliersSectionHeadingOpened from './PreferredSuppliersHeadingOpened';
import PreferredSuppliersSectionHeadingClosed from './PreferredSuppliersHeadingClosed';
import useSearch from './useSearch';

import './PreferredSuppliers.custom.scss';
import './PreferredSuppliers.theme.scss';

function PreferredSuppliersSection({ open, onOpen, onClose, onReset, optionsMap, checkedOptionsMap, onChange, onSave }) {
  const isOptionChecked = ({ name }) => get(checkedOptionsMap, name, false);
  const optionsList = useMemo(() => values(optionsMap), [optionsMap]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const checkedOptionsList = useMemo(() => optionsList.filter(isOptionChecked), [optionsList, checkedOptionsMap]);
  const [searchValue, setSearchValue, searchedOptions] = useSearch(optionsList);
  return (
    <Accordion
      className="preferred-suppliers-accordion-item"
      open={open}
      heading={
        open ? (
          <PreferredSuppliersSectionHeadingOpened
            checkedCount={get(checkedOptionsList, 'length')}
            onClose={onClose}
            onReset={onReset}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        ) : (
          <PreferredSuppliersSectionHeadingClosed onOpen={onOpen} checkedOptionsList={checkedOptionsList} />
        )
      }
      body={
        <div className="profile-settings-accordion-row__content">
          <div className="preferences-accordion-item__wrapper">
            <div className="preferred-suppliers-accordion-item__suppliers-list">
              {searchedOptions.map(({ name, label }) => (
                <Checkbox
                  key={name}
                  label={label}
                  onChange={(event) => {
                    onChange(name, event.target.checked);
                  }}
                  checked={isOptionChecked({ name })}
                  id={`preferred-supplier-${name}`}
                />
              ))}
            </div>
          </div>
          <div className="profile-settings-accordion-row__content_button">
            <Button
              onClick={onSave}
              buttonConfig={{
                className: 'preferred-suppliers-accordion-item__save-button',
                type: 'primary',
                size: 'sm',
                label: 'Save',
                e2eName: 'preferred-suppliers-save',
              }}
              iconConfig={{
                name: 'chevron-right',
              }}
            />
          </div>
        </div>
      }
    />
  );
}

PreferredSuppliersSection.defaultProps = {
  onOpen: () => {},
  onClose: () => {},
  onReset: () => {},
  onSave: () => {},
  onChange: () => {},
};

PreferredSuppliersSection.propTypes = {
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
  optionsMap: PropTypes.object.isRequired,
  checkedOptionsMap: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
};

export default PreferredSuppliersSection;
